export default "__VITE_ASSET__DS4700LF__"